/**
 * Image upload Handling Object
 */
var plek_gallery_handler = {

    nonce: null,
    album_ids: null,
    max_upload_size: 0,
    files_to_upload: [],
    files_count: 0, //The original count of files to upload
    upload_loop: 0,
    max_images_social_media: 10,

    construct() {

        jQuery('.image_upload_add_btn').on('click', function (event) {
            plek_gallery_handler.add_images_click_action(this);
        });
        jQuery('.image_upload_smp_add_btn').on('click', function (event) {
            plek_gallery_handler.add_smp_images_click_action(this);
        });
        jQuery('#review_images_upload_btn').on('click', (event) => {
            if (this.files_to_upload.length > 0) {
                plekerror.display_error(null, __('Upload in progress. Please wait till its done.', 'plekvetica'), 'Image upload error');
                return;
            }
            const filelist = jQuery('#review_images').prop('files');
            this.files_to_upload = Array.from(filelist);
            this.files_count = this.files_to_upload.length; //This is used to calculate the real index of the file

            if (event.currentTarget.dataset.gallery_id === 'smp') {
                //Image upload is the social media publisher, ignore standard upload
                const uploaded_img_count = jQuery('.image_upload_smp_add_btn[data-gallery_id="smp"]').parent().find('.image_count .nr').text();
                if (this.files_count > this.max_images_social_media || (this.files_count + parseInt(uploaded_img_count) > this.max_images_social_media)) {
                    plekerror.display_error(null, __('Too many images selected. Allowed are %d images max.', 'plekvetica').replace('%d', this.max_images_social_media), 'Image upload error');
                    this.files_to_upload.length = 0; //Reset the counter
                    return;
                }
                this.upload_images_click_action_smp(event.target);
            } else {
                //Add the button loader
                plek_main.activate_button_loader('#review_images_upload_btn', __('Uploading images...', 'plekvetica'));
                this.upload_loop = 0;
                plek_gallery_handler.upload_images_click_action_v3(event.target);
            }

        });
        jQuery('#images-uploaded-container').on('click', '.image_to_upload.upload_complete', function (event) {
            plek_gallery_handler.set_gallery_preview_click_action(this);
        });
        //Edit images container, set preview image
        jQuery(document).on('click', '.gallery-image-container .set-preview-image', function (event) {
            const img_con = jQuery(event.target).closest('.gallery-image-item');
            const image_id = jQuery(img_con).data('image_id');
            const gallery_id = jQuery(img_con).closest('.gallery-image-container').data('gallery_id');
            plek_gallery_handler.set_gallery_preview_click_action(img_con, gallery_id, image_id);
        });

        jQuery('#review_images').on('change', function (event) {
            plek_gallery_handler.image_upload_form_change_action(this);
        });

        jQuery(document).on("click", '.gallery-image-item .remove-image', function (e) {
            const id = jQuery(e.target).parent().data('image_id');
            plek_gallery_handler.delete_image(id);
        });
        jQuery(document).on("click", '.image_edit_images', function (e) {
            if (jQuery(e.target).css('opacity') === "0") {
                return;
            }
            const gallery_id = jQuery(e.target).data('gallery_id');
            //Hide the upload container
            jQuery('#event-review-images-upload-container').hide();
            jQuery('#images-uploaded-container').hide();
            plek_gallery_handler.get_images_of_gallery(gallery_id, e.target);
        });

        jQuery(document).ready(() => {
            if (!empty(jQuery('#event-review-images-container'))) {
                jQuery('#event-review-images-container').sortable(); //Make the Band list sortable
                plek_gallery_handler.wp_editor_shortcode_visualizer();
            }
            if (!empty(jQuery('#event-sm-publisher-images-container'))) {
                jQuery('#event-sm-publisher-images-container').sortable(); //Make the sm image previews list sortable
            }
            if (!empty(jQuery('#mentions > div'))) {
                jQuery('#mentions > div').sortable(); //Make the sm mentions list sortable
            }
        });

    },


    /**
     * Creates a new gallery
     * @param {string} event_id - The id of the event
     * @param {string} band_id - The id of the band. This is used to create the correct album for multi-day events in php
     */
    create_gallery(event_id, band_id, album_id) {
        var datab = new FormData();
        datab.append('action', 'plek_ajax_gallery_actions');
        datab.append('do', 'add_gallery');
        datab.append('event_id', event_id);
        datab.append('album_id', album_id);
        datab.append('band_id', band_id);

        return plek_main.send_form(datab, false, 'create_gallery_' + event_id + '_' + album_id + '_' + band_id, (response) => {
            let gallery_id = plek_main.get_success_item_from_ajax_request(response, 'gallery_id');
            return (!empty(gallery_id)) ? gallery_id : false; //The newly added gallery id
        });
    },

    /**
     * Creates a new NGG Album
     * @param {string} event_id - The id of the event
     * @param {string} band_id - The id of the band. This is used to create the correct album for multi-day events in php
     */
    create_album(event_id = '', band_id = '') {
        var datab = new FormData();
        datab.append('action', 'plek_ajax_gallery_actions');
        datab.append('do', 'add_album');
        datab.append('event_id', event_id);
        datab.append('band_id', band_id);

        return plek_main.send_form(datab, false, 'create_album_' + event_id + '_' + band_id, (response) => {
            //No errors, all good.
            let album_id = plek_main.get_success_item_from_ajax_request(response, 'album_id');
            let multiday = plek_main.get_success_item_from_ajax_request(response, 'is_multiday');

            //Checks if event is multi-day. If not, it will add the album id to all the band_gallery items.
            if (!multiday) {
                jQuery('.review_band_images_container .image_upload_add_btn').data('album_id', album_id);
            }
            return (!empty(album_id)) ? album_id : false; //The newly added album id
        });
    },

    wp_editor_shortcode_visualizer() {
        var ed = tinymce.get('event_text_review');
        if (!ed) return;

        var TAG = 'plek_insert_review_gallery';
        var RE = new RegExp('\\[' + TAG + '(?:\\s+[^\\]]*)?\\]', 'g');
        if (typeof plek_gallery_handler.gallery_info !== 'object') {
            plek_gallery_handler.gallery_info = plek_main.is_valid_JSON(plek_gallery_handler.gallery_info) ? JSON.parse(plek_gallery_handler.gallery_info) : [];
        }

        function toPh(html) {
            return html.replace(RE, function (shortcode) {
                var esc = shortcode.replace(/"/g, '&quot;');
                //Get the gallery ids
                const search_ids = shortcode.match(/\[plek_insert_review_gallery\s+gallery_id\s*=\s*([0-9,]+)\]/);
                if (!search_ids) {
                    return shortcode;
                }
                const search_id_arr = search_ids[1].split(',');
                let img_con = "";
                search_id_arr.forEach((id, index) => {
                    if (empty(plek_gallery_handler.gallery_info[id])) {
                        plek_gallery_handler.gallery_info[id].previewpic_thumb = "";
                        plek_gallery_handler.gallery_info[id].title = "Gallery title not found";
                    }
                    img_con += '<p class="plek-gallery-preview-item mceNonEditable" contenteditable="false">' +
                        '<img class="plek-gallery-ph" ' +
                        'src="' + plek_gallery_handler.gallery_info[id].previewpic_thumb + '" ' +
                        'alt="' + plek_gallery_handler.gallery_info[id].title + '" ' +
                        '/>' + plek_gallery_handler.gallery_info[id].title + '</p>'
                });
                return '<div class="plek-gallery-preview-con mceNonEditable" ' +
                    'contenteditable="false" data-shortcode="' + esc + '" >' + img_con + '</div>';
            });
        }
        function toSc(html) {
            const previews = html.match(/<div class="plek-gallery-preview-con mceNonEditable" contenteditable="false" data-shortcode="([^"]+)">[\s\S]*?<\/div>/g);
            if (!previews) {
                return html;
            }
            return html.replace(/<div class="plek-gallery-preview-con mceNonEditable" contenteditable="false" data-shortcode="([^"]+)">[\s\S]*?<\/div>/g, function (container) {
                var shortcode = container.match(/data-shortcode="([^"]*)"/);
                if (!shortcode) {
                    console.error('Failed to get shortcode');
                    return container;
                }
                return shortcode[1].replace(/&quot;/g, '"');
            });

        }

        // Convert current content
        ed.setContent(toPh(ed.getContent({ format: 'raw' })), { format: 'raw' });

        // Keep conversions in sync
        ed.on('BeforeSetContent', function (e) { if (e.content) e.content = toPh(e.content); });
        ed.on('PostProcess', function (e) { if (e.get) e.content = toSc(e.content); });
        ed.on('GetContent', function (e) { if (e.content) e.content = toSc(e.content); });

    },

    /**
     * Fires when the button is clicked to add new images
     * If no album is set, the function will create a new album
     * 
     * @todo: block the button action to avoid creating multiple galleries / Albums
     * @param {object} button The clicked button 
     */
    async add_images_click_action(button) {

        let img_con = jQuery('#event-review-images-upload-container');
        const gallery_id_before_album_gallery_creation = jQuery(button).attr('data-gallery_id');
        //activate the loader button
        plek_main.activate_button_loader(button);

        //Hide the edit Image container and delete existing inputs
        jQuery('#event-review-images-edit-container').html("");
        jQuery("input[type='file']").val('');

        if (plek_gallery_handler.lock_add_images_button === true) {
            plekerror.display_error(null, __('Please wait for the album and galleries to be created.', 'plekvetica'));
            return;
        }
        plek_gallery_handler.lock_add_images_button = true;

        //Hide the upload container
        img_con.hide();

        //Checks if the gallery and albums are set for the band.
        let album_gallery_created = await plek_gallery_handler.check_album_and_gallery_ids(button);

        if (!album_gallery_created) {
            plekerror.display_error(null, __('Error while creating album or gallery', 'plekvetica'), __('Error', 'plekvetica'));
        }

        //deactivate the loader button after gallery / album creation
        plek_main.deactivate_button_loader(button);

        let band_id = jQuery(button).attr('data-band_id');
        let gallery_id = jQuery(button).attr('data-gallery_id');
        let album_id = jQuery(button).attr('data-album_id');
        const is_offloaded = jQuery(button).attr('data-is_offloaded');
        const is_new_gallery = (empty(gallery_id_before_album_gallery_creation)) ? 'true' : 'false';

        console.debug('Gallery ID: ' + gallery_id);

        //Nothing to create / All created, show upload dialog
        let upload_btn = img_con.find('#review_images_upload_btn');

        img_con.show();

        //Set the gallery name
        let band_name = jQuery(button).parent().find('.band_name').text();
        let band_playtime = jQuery(button).parent().find('.playtime').text();
        jQuery('#event-review-images-upload-container').find('.gallery_title').text(band_playtime + ' ' + band_name);

        //Empty all the Images from before
        jQuery('#images-uploaded-container').html('');
        jQuery('#review_images').val('');

        upload_btn.attr('data-gallery_id', gallery_id);
        upload_btn.attr('data-album_id', album_id);
        upload_btn.attr('data-band_id', band_id);
        upload_btn.attr('data-is_offloaded', is_offloaded);
        upload_btn.attr('data-is_new_gallery', is_new_gallery);
        //Set the default text
        upload_btn.text(__('Select Pictures', 'plekvetica'));

        //Add the Icon to the button
        //jQuery(button).find('.image_upload_status').addClass('status-ok');
        this.update_gallery_button_status(gallery_id, 'done');

        //Scroll to the container
        let pos_top = img_con.position().top;
        let win_height = jQuery(window).height() / 2;
        jQuery('html').animate({ scrollTop: pos_top - win_height }, 600);

        plek_gallery_handler.lock_add_images_button = false;
    },
    /**
     * Fires when the button is clicked to add new images to the social media gallery
     * @param {object} button The clicked button 
     */
    async add_smp_images_click_action(button) {

        let img_con = jQuery('#event-review-images-upload-container');

        //Hide the edit Image container and delete existing inputs
        jQuery('#event-review-images-edit-container').html("");
        jQuery("input[type='file']").val('');

        //Hide the upload container
        img_con.hide();

        let band_id = 'smp';
        let gallery_id = 'smp';
        let album_id = 'smp';


        //Nothing to create / All created, show upload dialog
        let upload_btn = img_con.find('#review_images_upload_btn');

        img_con.show();

        //Set the gallery name
        jQuery('#event-review-images-upload-container').find('.gallery_title').text(__('Upload pictures for social media', 'plekvetica'));

        //Empty all the Images from before
        jQuery('#images-uploaded-container').html('');
        jQuery('#review_images').val('');

        upload_btn.attr('data-gallery_id', gallery_id);
        upload_btn.attr('data-album_id', album_id);
        upload_btn.attr('data-band_id', band_id);

        //Set the default text
        upload_btn.text(__('Select Pictures', 'plekvetica'));

        //Add the Icon to the button
        //jQuery(button).find('.image_upload_status').addClass('status-ok');
        this.update_gallery_button_status(gallery_id, 'done');

        //Scroll to the container
        let pos_top = img_con.position().top;
        let win_height = jQuery(window).height() / 2;
        jQuery('html').animate({ scrollTop: pos_top - win_height }, 600);

    },

    /**
     * Checks if the album and gallery id's exists. If not, it will create them
     */
    async check_album_and_gallery_ids(button) {
        try {
            let gallery_id = jQuery(button).attr('data-gallery_id');
            let album_id = jQuery(button).attr('data-album_id');
            let event_id = jQuery('#event_id').val();
            let band_id = jQuery(button).attr('data-band_id');
            if (empty(album_id)) {
                //No album set so far
                let new_album_id = await plek_gallery_handler.create_album(event_id, band_id);
                if (new_album_id === false) {
                    console.log(__('Error while creating a new album', 'plekvetica'));
                    return false;
                }
                album_id = new_album_id;
                jQuery(button).attr('data-album_id', new_album_id);
            }
            if (empty(gallery_id)) {
                let new_gallery_id = await plek_gallery_handler.create_gallery(event_id, band_id, album_id);
                if (new_gallery_id === false) {
                    console.log(__('Error while creating a new gallery', 'plekvetica'));
                    return false;
                }
                jQuery(button).attr('data-gallery_id', new_gallery_id);
            }
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    },
    /**
     * Updates the css of the add gallery/album button 
     * @param {int} gallery_id The ID of the gallery to change the button type from
     * @param {string} status_type Status to set. done, uploading and missing are accepted.
     * @returns 
     */
    update_gallery_button_status(gallery_id, status_type) {
        let css_status = '';
        switch (status_type) {
            case 'done':
                css_status = 'status-ok';
                break;
            case 'uploading':
                css_status = 'status-uploading';
                break;

            default: //status missing
                css_status = 'status-missing';
                break;
        }
        let button = jQuery(`.image_upload_add_btn[data-gallery_id='${gallery_id}']`).find('.image_upload_status');
        //Remove the previous status
        button.removeClass('status-missing');
        button.removeClass('status-ok');
        button.removeClass('status-uploading');

        //Set the new status
        button.addClass(css_status);
        return;
    },

    /**
 * Fires when the button is clicked to upload images
 * @deprecated 5.8 Use upload_images_click_action_v3
 * @param {object} button The clicked button 
 * @param {int} batch_size how many pictures should be uploaded simultaneously  
 */
    async upload_images_click_action_v2(button, batch_size = 5) {
        const gallery_id = jQuery(button).attr('data-gallery_id');
        const album_id = jQuery(button).attr('data-album_id');
        const is_offloaded = jQuery(button).attr('data-is_offloaded');
        const is_new_gallery = jQuery(button).attr('data-is_new_gallery');

        if (this.files_to_upload.length === 0 || typeof this.files_to_upload !== "object") {
            plekerror.display_error(null, __('No Images selected!', 'plekvetica'), 'Image upload error');
            return;
        }


        //Set the button to status uploading
        this.update_gallery_button_status(gallery_id, 'uploading');

        const image_upload_con = '#images-uploaded-container';
        const items = jQuery(image_upload_con + ' .image_to_upload');
        jQuery(image_upload_con).attr('data-album_id', album_id);
        jQuery(image_upload_con).attr('data-gallery_id', gallery_id);

        if (!empty(this.files_to_upload)) {
            //In case there is only one image, there is no reason to run this code.
            let loop = 1;
            const uploads = Array.from(this.files_to_upload).map(async (upload, index) => {
                if (upload.size > plek_gallery_handler.max_upload_size) {
                    //Skip item if file size to big
                    return;
                }
                if (this.upload_loop > batch_size) {
                    //skip if batch size reached. Since we start at 0, its >=
                    return;
                }
                loop++;
                this.files_to_upload.shift(); //Removes the first element
                //Upload the images
                return this.do_upload_image(upload, gallery_id, index, is_offloaded, is_new_gallery);
            }); //End Array.from

            await Promise.all(uploads);
            if (this.files_to_upload.length > 0) {
                this.upload_images_click_action_v2(button, batch_size); //Run it again till all files are uploaded
            }
        }
    },

    /**
     * Uploads all the selected images to the gallery.
     * @param {object} button The button that was clicked to upload the images.
     * @param {int} [batch_size=5] The number of images to upload in parallel.
     * @returns {Promise} The promise of the ajax request.
     */
    async upload_images_click_action_v3(button, batch_size = 5) {
        const gallery_id = jQuery(button).attr('data-gallery_id');
        const album_id = jQuery(button).attr('data-album_id');
        const is_offloaded = jQuery(button).attr('data-is_offloaded');
        const is_new_gallery = jQuery(button).attr('data-is_new_gallery');

        if (!Array.isArray(this.files_to_upload) || this.files_to_upload.length === 0) {
            plekerror.display_error(null, __('No Images selected!', 'plekvetica'), 'Image upload error');
            return;
        }

        // Set the button to status uploading
        this.update_gallery_button_status(gallery_id, 'uploading');

        const image_upload_con = '#images-uploaded-container';
        jQuery(image_upload_con).attr('data-album_id', album_id);
        jQuery(image_upload_con).attr('data-gallery_id', gallery_id);

        // Batch processing
        while (this.files_to_upload.length > 0) {
            let uploads = [];
            const originalLength = this.files_to_upload.length;
            for (let i = 0; i < Math.min(batch_size, originalLength); i++) {
                console.debug("Files left:" + this.files_to_upload.length +
                    " batch size: " + batch_size +
                    " current index: " + i);
                const upload = this.files_to_upload[0];
                if (upload.size > plek_gallery_handler.max_upload_size) {
                    this.files_to_upload.shift(); // Remove item if not processed
                    continue; // Skip oversized files
                }
                uploads.push(this.do_upload_image(upload, gallery_id, i, is_offloaded, is_new_gallery));
                this.files_to_upload.shift();
            }

            try {
                await Promise.all(uploads);
            } catch (error) {
                console.error('Error occurred during image upload:', error);
            }
        }
        //All done, log image upload
        const log_upload = new FormData;
        log_upload.append('action', 'plek_ajax_gallery_actions');
        log_upload.append('do', 'log_image_upload');
        log_upload.append('nr_images', this.files_count);
        log_upload.append('is_offloaded', is_offloaded);
        log_upload.append('gallery_id', gallery_id);
        log_upload.append('album_id', album_id);
        log_upload.append('event_id', jQuery('#event_id').val());
        plek_main.send_log(log_upload);
    },

    async upload_images_click_action_smp(button, batch_size = 5) {
        const gallery_id = 'smp';
        const album_id = 'smp';


        if (!Array.isArray(this.files_to_upload) || this.files_to_upload.length === 0) {
            plekerror.display_error(null, __('No Images selected!', 'plekvetica'), 'Image upload error');
            return;
        }

        // Set the button to status uploading
        this.update_gallery_button_status(gallery_id, 'uploading');

        const image_upload_con = '#images-uploaded-container';
        jQuery(image_upload_con).attr('data-album_id', album_id);
        jQuery(image_upload_con).attr('data-gallery_id', gallery_id);

        // Batch processing
        while (this.files_to_upload.length > 0) {
            let uploads = [];
            const originalLength = this.files_to_upload.length;
            for (let i = 0; i < Math.min(batch_size, originalLength); i++) {
                console.debug("Files left:" + this.files_to_upload.length +
                    " batch size: " + batch_size +
                    " current index: " + i);
                const upload = this.files_to_upload[0];
                if (upload.size > plek_gallery_handler.max_upload_size) {
                    this.files_to_upload.shift(); // Remove item if not processed
                    continue; // Skip oversized files
                }
                uploads.push(this.do_upload_image(upload, gallery_id, i, false, false));
                this.files_to_upload.shift();
            }

            try {
                await Promise.all(uploads);
            } catch (error) {
                console.error('Error occurred during image upload:', error);
            }
        }
    },


    /**
     * Uploads a single image to the gallery
     * @param {object} upload The file to upload
     * @param {int} gallery_id The id of the gallery
     * @param {int} index The index of the current image in the list of images to upload
     * @param {bool} is_offloaded If the gallery is offloaded
     * @param {bool} is_new_gallery If the gallery is new
     * @returns {Promise} The promise of the ajax request
     */
    async do_upload_image(upload, gallery_id, index, is_offloaded, is_new_gallery) {
        const formdata = new FormData();
        formdata.append('file_data', upload);
        formdata.append('action', 'plek_ajax_gallery_actions');
        formdata.append('do', 'add_image');
        formdata.append('gallery_id', gallery_id);
        formdata.append('is_offloaded', is_offloaded);
        formdata.append('is_new_gallery', is_new_gallery);
        formdata.append('event_id', plekevent.get_field_value('event_id'));

        //Mark the image as being uploaded
        const preview_item = '#images-uploaded-container [data-name="' + upload.name + '"]';
        jQuery(preview_item).addClass('upload_in_progress');
        jQuery(preview_item).addClass('current_upload');

        const button = document.getElementById('review_images_upload_btn');
        const image_upload = await plek_main.send_form(formdata, button, 'image_upload_' + index, (response, button, attr) => {
            const image_id = plek_main.get_success_item_from_ajax_request(response);
            const image_offloaded = plek_main.get_success_item_from_ajax_request(response, 'image_offloaded');
            const gallery_id = attr.gallery_id;
            if (image_offloaded) {
                jQuery('#review_images_upload_btn').attr('data-is_offloaded', 'true');
                jQuery('.image_upload_add_btn[data-gallery_id=' + gallery_id + ']').attr('data-is_offloaded', 'true');
            }
            const upload = attr.upload;
            //Display the information about the upload
            plek_gallery_handler.upload_image_progress_update(upload.name, gallery_id, true, image_id);
            return true;
        }, false, false, { upload: upload, gallery_id: gallery_id });

        if (image_upload !== false) {
            return true;
        }
        console.error("Failed to upload picture");
        return false;
    },

    /**
     * Sets the preview image for a gallery
     * @param {object} image The dom element of the image
     * @param {int} gallery_id The id of the gallery
     * @param {int} image_id The id of the image to set as title image
     * @returns {Promise} The promise of the ajax request
     */
    set_gallery_preview_click_action(image, gallery_id = null, image_id = null) {
        if (empty(gallery_id)) {
            gallery_id = jQuery(image).parent().attr('data-gallery_id');
        }
        if (empty(image_id)) {
            image_id = jQuery(image).attr('data-image_id');
        }
        let img_element = jQuery(image).find('img');

        let formdata = new FormData();
        formdata.append('action', 'plek_ajax_gallery_actions');
        formdata.append('do', 'set_preview_image');
        formdata.append('gallery_id', gallery_id);
        formdata.append('image_id', image_id);

        return plek_main.send_form(formdata, img_element, 'set_gallery_preview_' + image_id, (response, button, atts) => {
            plek_main.form_success_callback(response, button, atts);
            const img_element = atts.img_element;
            //Remove the gallery preview class from all other image containers
            jQuery('.image_to_upload.upload_complete img').removeClass('gallery-preview');
            jQuery('.gallery-image-container img').removeClass('gallery-preview');
            //Mark the Image as title image
            jQuery(img_element).addClass('gallery-preview');
        }, false, false, { img_element: img_element });
    },

    /**
     * Displays a preview of all the images about to upload.
     * 
     * @param {object} files_input The file Input
     */
    image_upload_form_change_action(files_input) {
        var image_container = jQuery('#images-uploaded-container');
        image_container.show();

        //Empty all the items and reset the counter
        jQuery(image_container).html('');


        //The images
        let files = jQuery('#review_images').prop('files');

        //get the existing count of the items
        let existing_count = jQuery('#images-uploaded-container .image_to_upload').length;

        jQuery.each(files, function (index, upload) {
            //Display the preview
            index = existing_count + index;
            if (upload.size > plek_gallery_handler.max_upload_size) {
                const max = Math.round((plek_gallery_handler.max_upload_size) / 1000) + ' ' + __('kb maximal', 'plekvetica');
                plekerror.display_error(null, __('Imagesize is to big for: ', 'plekvetica') + '<br/>' + upload.name + '<br/>' + max, 'Image upload error');
                return;
            }
            jQuery(image_container).append(`<div id='image_${index}' data-name='${upload.name}' class='image_to_upload'><img/>${upload.name}</div>`);
            var insert_image = jQuery(image_container).find('#image_' + index);

            let image = plek_main.get_preview_image(insert_image, upload);
            if (!image) {
                plekerror.display_error(null, __('The given File is not a valid image', 'plekvetica'), 'Image upload error');
                return;
            }
        });
        //Change button label
        if (files.length > 0) {
            const upload_images_text = __('Upload %s images', 'plekvetica').replace("%s", files.length);
            jQuery("#review_images_upload_btn").text(upload_images_text);
        } else {
            jQuery("#review_images_upload_btn").text(__('Select images', 'plekvetica'));
        }
    },

    /**
     * Displays the information about the upload of the images.
     * @param {int} filename The filename
     * @param {int} gallery_id Id of the gallery
     * @param {bool} is_success If the upload was successfully or not
     * @param {int} image_id The ID of the Uploaded Image
     */
    upload_image_progress_update(filename, gallery_id, is_success, image_id) {
        let container = '#images-uploaded-container';
        let button = (gallery_id === 'smp') ? jQuery(`.image_upload_smp_add_btn[data-gallery_id='${gallery_id}']`) : jQuery(`.image_upload_add_btn[data-gallery_id='${gallery_id}']`);
        let button_status = jQuery(button).find('.image_upload_status');
        let item = jQuery(container + ' [data-name="' + filename + '"]');
        let items_total = jQuery(container + ' .image_to_upload').length;

        if (empty(item)) {
            return false;
        }

        //Indicator for the preview picture
        if (is_success) {
            jQuery(item).addClass("upload_complete");
            jQuery(item).attr("data-image_id", image_id);
        } else {
            jQuery(item).addClass("upload_failed");
        }
        jQuery(item).removeClass('upload_in_progress');

        let items_done = jQuery(container + ' .image_to_upload.current_upload.upload_complete').length;
        let items_failed = jQuery(container + ' .image_to_upload.current_upload.upload_failed').length;
        let percentage_complete = ((items_done + items_failed) / items_total * 100);

        //Set the submit button text
        let btn_text = __('Upload: ', 'plekvetica') + Math.round(percentage_complete) + '%';
        jQuery('#review_images_upload_btn').text(btn_text);

        //Update picture count
        let old_count = jQuery(button).parent().find('.image_count .nr').text();
        jQuery(button).parent().find('.image_count .nr').text(parseInt(old_count) + 1); //Add one to the existing

        if (percentage_complete === 100) {
            //All uploaded.            

            //Empty the file upload input
            jQuery('#review_images').val('');

            this.update_gallery_button_status(gallery_id, 'done');

            jQuery(container).find('.image_to_upload').removeClass('current_upload');

            plek_main.deactivate_button_loader('#review_images_upload_btn', __('Upload images', 'plekvetica'));

            plekerror.display_info(__('Image upload', 'plekvetica'), __('Images uploaded: ', 'plekvetica') + items_done);

            //Maybe display the edit gallery button
            const geb = jQuery(button).parent().find('.image_edit_images')
            geb.removeClass('plek-button-hidden');
            geb.data('gallery_id', gallery_id);

        }
        return;

    },

    /**
     * Gets all the Gallery ids of the Band, which have images uploaded.
     * @returns object The ids.
     */
    get_band_gallery_sortorder() {
        var gallery_ids = {};
        let container = jQuery('#event-review-images-container');

        jQuery(container).find('.review_band_images_container').each((index, item) => {
            let gallery_id = jQuery(item).find('.image_upload_add_btn ').attr('data-gallery_id');
            let album_id = jQuery(item).find('.image_upload_add_btn ').attr('data-album_id');
            if (!empty(gallery_id)) {
                if (empty(gallery_ids[album_id])) {
                    gallery_ids[album_id] = [];
                }
                gallery_ids[album_id].push(gallery_id);
            }
        });
        return gallery_ids;
    },


    /**
     * Deletes an image from the gallery
     * @param {int} image_id The id of the image to delete
     * @returns {Promise} The promise of the ajax request
     */
    delete_image(image_id) {
        let gallery_id = jQuery(`.remove-image[data-image_id='${image_id}']`).closest('.gallery-image-container').data('gallery_id');
        let formdata = new FormData();
        formdata.append('action', 'plek_ajax_gallery_actions');
        formdata.append('do', 'remove_image');
        formdata.append('image_id', image_id);
        formdata.append('gallery_id', gallery_id);
        formdata.append('event_id', plekevent.get_field_value('event_id'));

        const button = document.querySelector(`.gallery-image-item[data-image_id='${image_id}'] img`);
        return plek_main.send_form(formdata, button, 'delete_image_' + image_id, (response, button, atts) => {
            plek_main.form_success_callback(response); //Shows the success message

            const gallery_id = atts.gallery_id;
            //Remove the image from the grid
            const image_id = plek_main.get_success_item_from_ajax_request(response, 'image_id');
            jQuery(`.gallery-image-item[data-image_id="${image_id}"]`).remove();

            //Decrease the image counter
            let add_button = (gallery_id === 'smp') ? jQuery(`.image_upload_smp_add_btn[data-gallery_id='${gallery_id}']`) : jQuery(`.image_upload_add_btn[data-gallery_id='${gallery_id}']`);
            let counter = jQuery(add_button).parent().find('.image_count .nr');
            let count = counter.text();
            counter.text(parseInt(count) - 1); //Add one to the existing
            return true;

        }, false, false, { gallery_id: gallery_id });
    },


    /**
     * Retrieves and displays the images of a specified gallery.
     * 
     * @param {int} gallery_id - The ID of the gallery whose images are to be retrieved.
     * @param {object} button - The button element that initiated the request.
     * @returns {Promise} The promise of the AJAX request, resolving with the HTML content of the gallery images.
     */

    get_images_of_gallery(gallery_id, button) {
        let formdata = new FormData();
        formdata.append('action', 'plek_ajax_gallery_actions');
        formdata.append('do', 'get_images_html');
        formdata.append('gallery_id', gallery_id);
        formdata.append('event_id', jQuery('#event_id').val());

        return plek_main.send_form(formdata, button, 'get_images_of_gallery_' + gallery_id, (response) => {
            const html_data = plek_main.get_success_item_from_ajax_request(response, 'message');
            jQuery('#event-review-images-edit-container').html(html_data);
            return true;
        });
    }

}

document.addEventListener('DOMContentLoaded', function () {
    plek_gallery_handler.construct();
});
